import React from 'react';
import styled from 'styled-components/macro';

interface Props {
    children: React.ReactNode;
    light?: boolean;
    className?: string;
}

export const ScrollHorizontal = (props: Props): JSX.Element => {
    return (
        <S_ScrollHorizontal $light={props.light} className={props.className}>
            {props.children}
        </S_ScrollHorizontal>
    );
};

const S_ScrollHorizontal = styled.div<{ $light: boolean }>`
    overflow-y: hidden;
    overflow-x: scroll;
    width: 100%;
    &::-webkit-scrollbar,
    &::-webkit-scrollbar {
        width: 15px;
    }
    &::-webkit-scrollbar-track {
        background-color: ${(props) => (props.$light ? '#dfdfdf' : '#242424')};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${(props) => (props.$light ? '#bababa' : '#414141')};
        border-radius: 0px;
    }
`;
